import { isNumberString } from "@/shared/utils/is-number-string";
import { OperatorEnum } from "@spz/shared-domain";

export type IntergerFilterValueItem = number | undefined | null | string;

const parseValue = (val: string | number): string | number => {
  if (isNumberString(val)) return Number(val);
  return val;
};

export const getIntegerFilterValue = ({
  column,
  min: _min,
  max: _max,
}: {
  column: string;
  min: IntergerFilterValueItem;
  max: IntergerFilterValueItem;
}) => {
  const min = _min ?? null;
  const max = _max ?? null;

  if (min !== null && max !== null)
    return {
      column,
      operator: OperatorEnum.BETWEEN,
      value: [parseValue(min), parseValue(max)],
    };
  if (min !== null)
    return {
      column,
      operator: OperatorEnum.GTE,
      value: parseValue(min),
    };
  if (max !== null)
    return {
      column,
      operator: OperatorEnum.LTE,
      value: parseValue(max),
    };
  return null;
};
